import { Injectable } from '@angular/core';
import { RestErrorEventCategory, RestErrorType } from '../../domain/error.domain';
import type { BackendError, BackendErrorResponse } from '../../domain/error.domain';
import type { RestErrorHandler } from './rest-error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class RestSystemErrorHandlerService  implements RestErrorHandler {

  handleErrors(errors: Array<BackendError>): BackendErrorResponse {
    let result: BackendErrorResponse;
    for (const error of errors) {
      if (error.type === RestErrorType.SYSTEM) {
        result =  { ...error, category: RestErrorEventCategory.ERROR };
        break;
      }
    }
    return result;
  }
}
